
import _i18n from '@ps/lang';
export default {
  props: {
    muted: {
      type: Boolean,
      default: false
    }
  },

  mounted: function mounted() {
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  },
  destroyed: function destroyed() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  },


  methods: {
    i18n: function i18n(path) {
      return _i18n.t(path);
    },
    handleVisibilityChange: function handleVisibilityChange() {
      // 当从当且浏览器 tab 切换到其他应用或其他 tab 时，一些 playable 会将静音状态修改为非静音状态，所以当切换回当前 tab 时，如果数据上是静音状态，则再次将音频切换到静音状态
      if (document.visibilityState === 'visible' && this.muted === true) {
        this.$emit('mute');
      }
    }
  }
};